var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDivitMilesLogoBwBordered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.94,
    height: 74.941,
    viewBox: "0 0 74.94 74.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26556",
    "data-name": "Group 26556",
    transform: "translate(1140.737 -2554.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37445",
    "data-name": "Path 37445",
    d: "M636.049,472.079a35.97,35.97,0,1,0,35.97,35.97A35.97,35.97,0,0,0,636.049,472.079Z",
    transform: "translate(-1739.316 2083.684)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26552",
    "data-name": "Group 26552",
    transform: "translate(-1120.075 2569.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M12.668,44.663h0L0,37.35v-10.5H11.992v4.354l15.372-8.874L11.992,13.457v4.356H0V7.313L12.668,0,38.679,15.018V29.645L12.669,44.663Z",
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivitMilesLogoBwBordered);
export default __webpack_public_path__ + "static/media/divit-miles-logo-bw-bordered.467744492f75cbf2d18c1dce1a4e9adf.svg";
export { ForwardRef as ReactComponent };